import React, { useMemo } from 'react';
import {
	Wrapper,
	Container,
	TableContainer,
	AnalysisDescription,
} from './DetailedAnalysis.styles';
import { defaultGridHeight } from './utils';
import { AgGridReact } from '@ag-grid-community/react';
import { useNonPreferedSuppliersContext } from 'contexts/CategoryInsightsKpi/NonPreferedSuppliersProvider';

const NonPreferedSuppliersExplore = () => {
	const { gridData } = useNonPreferedSuppliersContext();
	const gridStyle = useMemo(() => defaultGridHeight, []);

	return (
		<Wrapper>
			<Container>
				<AnalysisDescription>
					{`List of non-preferred suppliers as marked by the entity.`}
				</AnalysisDescription>
				<TableContainer>
					<div style={gridStyle} className="ag-theme-balham">
						<AgGridReact {...gridData} />
					</div>
				</TableContainer>
			</Container>
		</Wrapper>
	);
};

export default NonPreferedSuppliersExplore;
